import { createContext } from "react";

export interface NetworkStatusContextValue {
	isOnline: boolean;
}

const NetworkStatusContext = createContext<NetworkStatusContextValue>({ isOnline: true });

export default NetworkStatusContext;
